import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideSwiperLoader } from '@usheru-hff/shared/utils';
import { provideScrollRestoration } from '@usheru-hff/ui/router';

import { providePostBootstrapVersionLogger } from '@usheru-hff/shared/utils';

import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { provideLazyToast } from '@usheru-hff/sdk/notfication';
import { AppModule } from './app.module';
import { APP_ROUTES } from './app.routes';
import { currentGitVersion } from './version';

export const appConfig: ApplicationConfig = {
  providers: [
    provideSwiperLoader(),
    provideClientHydration(),
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'disabled',
        anchorScrolling: 'enabled'
      }),
      withViewTransitions()
    ),
    provideScrollRestoration(),
    importProvidersFrom(AppModule),
    provideLazyToast(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    providePostBootstrapVersionLogger(currentGitVersion),
    importProvidersFrom(NgProgressRouterModule)
  ]
};
